const config = [
  {
    header: 'Quality of Life',
    trackingFieldName: 'qol_open',
    className: 'clQol',
    help: '',
    contentConfig: [
      {
        type: 'variable',
        rows: [{ text: 'Walk Score' }, { key: 'walkscore' }],
      },
      {
        type: 'variable',
        rows: [
          { text: 'Average commute time to work' },
          { key: 'average_travel_time_to_work_min' },
        ],
      },
      {
        type: 'variable',
        rows: [
          { text: 'Public transit rating' },
          { key: 'public_transit_rating' },
        ],
      },
      {
        type: 'variable',
        rows: [
          { text: 'Violent crime rate per 100,000 inhabitants' },
          { key: 'violent_crime_rate' },
        ],
      },
      {
        type: 'variable',
        rows: [
          { text: 'Bars per 1,000 people' },
          { key: 'bars_per_1000_people' },
        ],
      },
      {
        type: 'variable',
        rows: [
          { text: 'Gyms per 1,000 people' },
          { key: 'gyms_per_1000_people' },
        ],
      },
    ],
  },
  {
    header: 'Weather',
    trackingFieldName: 'weather_open',
    className: 'clWeather',
    help: '',
    contentConfig: [
      {
        type: 'variable',
        rows: [{ key: 'weather' }],
      },
    ],
  },
];
export default config;
